/* tslint:disable */

declare var Object: any;
export interface SettingsTenantInterface {
  "key": string;
  "value": string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
}

export class SettingsTenant implements SettingsTenantInterface {
  "key": string;
  "value": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: SettingsTenantInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SettingsTenant`.
   */
  public static getModelName() {
    return "SettingsTenant";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SettingsTenant for dynamic purposes.
  **/
  public static factory(data: SettingsTenantInterface): SettingsTenant{
    return new SettingsTenant(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SettingsTenant',
      plural: 'SettingsTenants',
      path: 'SettingsTenants',
      idName: 'id',
      properties: {
        "key": {
          name: 'key',
          type: 'string'
        },
        "value": {
          name: 'value',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
